import { FDealType, FOfferType, isAvailable } from '../../../../JsonQuery';
import { StarRatingContainer } from '../../containers/filters/StarRatingContainer';
import { IFilter } from '../../types/filters';

export const starRating: IFilter = {
  availability: isAvailable(FDealType.RentDaily, FOfferType.Hotel),
  component: StarRatingContainer,
};
